var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHeadIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0ZM14 26C7.38318 26 2 20.6168 2 14C2 7.38318 7.38318 2 14 2C20.6168 2 26 7.38318 26 14C26 20.6168 20.6168 26 14 26ZM20.7072 8.70715L15.4143 14L20.7072 19.2929L19.2929 20.7072L14.0001 15.4142L8.70715 20.7072L7.29291 19.2929L12.5858 14L7.29291 8.70715L8.70715 7.29291L14.0001 12.5858L19.2929 7.29291L20.7072 8.70715Z",
  fill: "#FDA700"
})));
export { SvgHeadIcon as ReactComponent };
export default __webpack_public_path__ + "assets/icons/head_icon.c7d912.svg";